import { createJSONRequest } from './create-request'

export const fetchTransitionPulseMonths = () => createJSONRequest({
  url: '/api/transition-reports',
  method: 'GET',
})

export const fetchTransitionPulse = (year: number, month: number) => createJSONRequest({
  url: `/api/transition-reports/${year}/${month}`,
  method: 'GET',
})
